export const KnowledgeUrl = "https://kb.modelve.com" as const;

export function parsePostfix(input: string, postFix: string) {
  if (/^https:\/\//i.test(postFix)) {
    return postFix;
  }
  return `${KnowledgeUrl}/doc/${cleanUrl(input)}/${postFix}`;
}

export function parseUrl(input: string) {
  return `${KnowledgeUrl}/doc/${cleanUrl(input)}`;
}

export function cleanUrl(input: string): string {
  // Strip index.md and normalize slashes
  const cleaned = input.replace(/index\.md$/, "").replace(/\/$/, ""); // strip trailing slash

  // Extract just the path segment (handle full URLs or raw paths)
  const path = cleaned.startsWith(KnowledgeUrl)
    ? cleaned.replace(KnowledgeUrl, "")
    : cleaned;

  // Normalize to /doc/... format
  const normalized =
    path.startsWith("/doc/") || path.startsWith("doc/")
      ? path.replace(/^\/?doc\//, "")
      : path.replace(/^\//, "");

  return normalized;
}

export function extractTitle(content: string) {
  const regex = /^# (.+)$/m;

  const match = content.match(regex);
  const title = match?.[1]?.trim() ?? null;

  return title;
}

export function parseBreadcrumbs(url: string) {
  return url
    .split("/")
    .filter((part) => !!part.length)
    .filter((part) => !part.includes("#"))
    .map((part, i, parts) => ({
      url: parts.slice(0, i + 1).join("/"),
      title: part
        .split("-")
        .map((part) => part[0].toUpperCase() + part.slice(1))
        .join(" ")
        .replace(".md", ""),
    }));
}
